import { User } from '@bioliberty/lifemind';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';
import { RESET_ALL_ACTION } from '../actions';

export type AdminViewState = {
  users: User[];
};

const initialState: AdminViewState = {
  users: []
};

const slice = createSlice({
  name: 'adminView',
  initialState,
  extraReducers: (builder) => builder.addCase(RESET_ALL_ACTION, () => initialState),
  reducers: {
    setUsers: (state, { payload: users }: PayloadAction<User[]>) => {
      state.users = users.sort((a, b) => a.lastName.localeCompare(b.lastName));
    },
    addUser: (state, { payload: user }: PayloadAction<User>) => {
      state.users = [...state.users, user].sort((a, b) => a.lastName.localeCompare(b.lastName));
    },
    updateUser: (state, { payload: { id, props } }: PayloadAction<{ id: string; props: Partial<User> }>) => {
      state.users = state.users.map((user) => {
        if (user.id === id) {
          return { ...user, ...props };
        }
        return user;
      });
    },
    deleteUser: (state, { payload: { id } }: PayloadAction<{ id: string }>) => {
      state.users = state.users.filter((user) => user.id !== id);
    }
  }
});

export default slice.reducer;

export const { setUsers, addUser, updateUser, deleteUser } = slice.actions;

export const getUsers =
  () =>
  (state: RootState): User[] =>
    state.adminView.users;
